export const money = (v) =>
  `RD$${Number(v || 0).toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fecha = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-DO", { day: "2-digit", month: "short", year: "numeric" });
};

export const fechaLarga = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-DO", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

export const diasRestantes = (iso) => {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / 86400000);
};

export const norm = (s = "") =>
  String(s).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const iniciales = (nombre = "") =>
  nombre.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
